"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: profile/profile-profile.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fprofile%2Fprofile-profile.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.statusToJSON = exports.statusFromJSON = exports.Profile = exports.Status = void 0;
const feature_1 = require("../feature/feature");
const protobufPackage = 'com.step.profile.proto';
var Status;
(function (Status) {
    Status["INVALID_STATUS"] = "INVALID_STATUS";
    Status["PRIVATE"] = "PRIVATE";
    Status["PUBLIC"] = "PUBLIC";
    Status["UNRECOGNIZED"] = "UNRECOGNIZED";
})(Status || (exports.Status = Status = {}));
function createBaseProfile() {
    return {
        displayName: '',
        pictureUrl: '',
        createdAtMs: '0',
        status: Status.INVALID_STATUS,
        hasPublicPayLink: false,
        features: [],
    };
}
exports.Profile = {
    fromJSON(object) {
        const message = {
            displayName: isSet(object.displayName) ? globalThis.String(object.displayName) : '',
            createdAtMs: isSet(object.createdAtMs) ? globalThis.String(object.createdAtMs) : '0',
            status: isSet(object.status) ? statusFromJSON(object.status) : Status.INVALID_STATUS,
            hasPublicPayLink: isSet(object.hasPublicPayLink)
                ? globalThis.Boolean(object.hasPublicPayLink)
                : false,
        };
        if (isSet(object.pictureUrl)) {
            message.pictureUrl = globalThis.String(object.pictureUrl);
        }
        if (globalThis.Array.isArray(object?.features)) {
            message.features = object.features.map((e) => feature_1.FeatureAssignment.fromJSON(e));
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.displayName !== '') {
            obj.displayName = message.displayName;
        }
        if (message.pictureUrl !== undefined && message.pictureUrl !== '') {
            obj.pictureUrl = message.pictureUrl;
        }
        if (message.createdAtMs !== '0') {
            obj.createdAtMs = message.createdAtMs;
        }
        if (message.status !== Status.INVALID_STATUS) {
            obj.status = statusToJSON(message.status);
        }
        if (message.hasPublicPayLink !== false) {
            obj.hasPublicPayLink = message.hasPublicPayLink;
        }
        if (message.features?.length) {
            obj.features = message.features.map((e) => feature_1.FeatureAssignment.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.Profile.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseProfile();
        message.displayName = object.displayName ?? '';
        message.pictureUrl = object.pictureUrl ?? '';
        message.createdAtMs = object.createdAtMs ?? '0';
        message.status = object.status ?? Status.INVALID_STATUS;
        message.hasPublicPayLink = object.hasPublicPayLink ?? false;
        message.features = object.features?.map((e) => feature_1.FeatureAssignment.fromPartial(e)) || [];
        return message;
    },
};
function statusFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_STATUS':
            return Status.INVALID_STATUS;
        case 1:
        case 'PRIVATE':
            return Status.PRIVATE;
        case 2:
        case 'PUBLIC':
            return Status.PUBLIC;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return Status.UNRECOGNIZED;
    }
}
exports.statusFromJSON = statusFromJSON;
function statusToJSON(object) {
    switch (object) {
        case Status.INVALID_STATUS:
            return 'INVALID_STATUS';
        case Status.PRIVATE:
            return 'PRIVATE';
        case Status.PUBLIC:
            return 'PUBLIC';
        case Status.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.statusToJSON = statusToJSON;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=profile-profile.js.map